<template>
  <div class="desc-type-a">
    <div>
      <b>{{ title }}</b>
      <br />
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotiTitleAndContent',
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    content: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
